import { http } from "../utils/http";
import { ENDPOINTS } from "../const/endpoints";
export const getUser = async () => {
  let res = await http.get(ENDPOINTS.user);
  return res;
};
export const login = async (payload: LoginPayload) => {
  let res: HttpResponse = await http.post(ENDPOINTS.login, payload);
  return res;
};